import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import utc from "dayjs/plugin/utc";
import type { ReactNode } from "react";
import type { Notification } from "~types/notification";

import "./BasePopoverNotificationItem.scss";
import { HtmlRenderer } from "~components/HtmlRenderer/HtmlRenderer";
import { NotificationStatuses } from "~enums/notificationStatuses.ts";

dayjs.extend(utc);
dayjs.extend(relativeTime);

export type DropdownNotificationItemBaseProps = {
  notification: Notification;
  onClick: (notification: Notification) => void;
  icon: string;
  actionButton?: ReactNode;
};

const BasePopoverNotificationItem = ({ notification, onClick, icon, actionButton }: DropdownNotificationItemBaseProps) => {
  const timeAgo = dayjs.utc(notification.createdAtUtc).local().fromNow();

  return (
    <div className={`popover-notification-item${notification.unread ? " is-unread" : ""}`} onClick={() => onClick(notification)}>
      <div className="popover-notification-icon">
        <i className={`fas ${icon}`} />
      </div>
      <div className="popover-notification-content">
        <div className="popover-notification-name">{notification.name || notification.key}</div>
        {notification.status !== NotificationStatuses.Failed && (
          <HtmlRenderer html={notification.description} className="popover-notification-description" />
        )}
        {notification.status === NotificationStatuses.Failed && <div className="popover-notification-error">{notification.error}</div>}
        <div className="popover-notification-time">{timeAgo}</div>
        {actionButton}
      </div>
    </div>
  );
};

export default BasePopoverNotificationItem;
